<template>
  <div
    v-if="hasContact"
    class="flex flex-wrap items-center gap-4 border-y border-white/10 py-3"
  >
    <a
      v-if="player.whatsapp"
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="detail-social-button hover:opacity-80"
      aria-label="Contactar por WhatsApp"
    >
      <IconFbochas name="whatsapp" :size="22" color="#a52121" />
    </a>
    <a
      v-if="player.phone"
      :href="`tel:${player.phone}`"
      class="detail-social-button hover:opacity-80"
      aria-label="Llamar por teléfono"
    >
      <IconFbochas name="phone" :size="22" color="#a52121" />
    </a>
    <a
      v-if="player.email"
      :href="`mailto:${player.email}`"
      class="detail-social-button hover:opacity-80"
      aria-label="Enviar email"
    >
      <IconFbochas name="mail" :size="22" color="#a52121" />
    </a>
    <a
      v-if="player.facebookUrl"
      :href="externalUrl(player.facebookUrl)"
      target="_blank"
      rel="noopener noreferrer"
      class="detail-social-button hover:opacity-80"
      aria-label="Ver Facebook"
    >
      <IconFbochas name="facebook" :size="22" color="#a52121" />
    </a>
    <a
      v-if="player.instagramUrl"
      :href="externalUrl(player.instagramUrl)"
      target="_blank"
      rel="noopener noreferrer"
      class="detail-social-button hover:opacity-80"
      aria-label="Ver Instagram"
    >
      <IconFbochas name="instagram" :size="22" color="#a52121" />
    </a>
  </div>
</template>

<script setup>
import { computed } from "vue";
import IconFbochas from "@/components/Icons/IconFbochas.vue";

const props = defineProps({
  player: { type: Object, required: true },
});

const hasContact = computed(() =>
  Boolean(
    props.player.phone ||
      props.player.email ||
      props.player.whatsapp ||
      props.player.facebookUrl ||
      props.player.instagramUrl,
  ),
);

const whatsappUrl = computed(() => {
  const number = String(props.player.whatsapp || "").replace(/\D/g, "");
  return number ? `https://wa.me/${number}` : "";
});

function externalUrl(value) {
  const url = String(value || "").trim();
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}
</script>
